import MainLayout from '../../layouts/MainLayout'

export default function FranchiseDevelopmentDayPresentation(): JSX.Element {
  const iframeStyles: any = {
    border: 0,
    boxShadow: '5px 5px 56px 0px rgba(0,0,0,0.25)'
  };

  const iframeWrapperStyles: any = {
    textAlign: 'center',
    minHeight: '600px',
    height: '100vh'
  }

  return (
    <MainLayout>
      <div className="max-w-screen-3xl mx-auto w-full">
        <div className="flex-grow lg:p-8 p-3 space-y-4 lg:space-y-8">

          <div className="flex flex-col items-center w-full bg-white rounded-xl p-4 lg:p-5">
            <div className="flex w-full mb-4">
              <header className="mb-4">
                <h1 className="sm:text-2xl text-xl font-bold">Banana Moon Franchise Development Day Presentation</h1>
              </header>
            </div>

            <div className="flex flex-col w-full">
              <div style={iframeWrapperStyles}>
                <iframe
                  src="/static/Banana_Moon_Franchise_Development_Day_Presentation_130624.pdf"
                  width={'100%'}
                  height={'100%'}
                  style={iframeStyles}
                  title="FranchiseDevelopmentDayPresentation"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  )
}
